import { Progress } from "@/components/ui/progress";
import { Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import getLink, { LINK_TYPE } from "@/lib/links";
import { fireJuneEvent } from "@/components/analytics/JuneAnalytics";
import { iCollection } from "@/services/collection";

export type infoStepperOutletContext = {
  setProgress: (n: number) => void;
};

export default function InfoStepper({
  loading,
  collection,
}: {
  loading: boolean;
  collection?: iCollection;
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [progress, setProgress] = useState(0);
  const infoSteps = [
    {
      title: "HotelData",
      url: "/hoteldata",
      key: "hotel_data",
    },
    {
      title: "HotelBookingEngine",
      url: "/hotelbookingengine",
      key: "bookingEngine",
    },
    {
      title: "HotelPrice",
      url: "/hotelprice",
      key: "price",
    },
    {
      title: "HotelBenefits",
      url: "/hotelbenefits",
      key: "hotel_benefits",
    },
    {
      title: "HotelChain",
      url: "/hotelchain",
      key: "hotel_chain",
    },
  ];

  const currPath =
    window.location.pathname.split("/").filter(Boolean).pop() || "";

  const currentStep = infoSteps.findIndex(
    (step) => step.url === "/" + currPath
  );

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="flex flex-col gap-4 px-6 py-10 md:gap-8 md:px-14 md:py-8 min-h-[calc(100dvh-theme(spacing.16)-theme(spacing.16))]">
      <div className="flex items-center justify-between">
        <p className="text-2xl font-medium">
          {t(`onboarding.${infoSteps[currentStep].key}_title`)}
        </p>
        <X
          className="cursor-pointer"
          onClick={() => {
            fireJuneEvent("onboarding_cancel", {
              collectionName: collection?.name,
              collectionId: collection?._id,
            });
            navigate(getLink(LINK_TYPE.HOME));
          }}
        />
      </div>
      {/* <p className="text-base text-gray-600">{t("onboarding.subtitle")}</p> */}
      <div className="relative">
        <Progress value={progress} className="h-2" />
        <div className="absolute w-full top-0 left-0 h-4 flex items-center justify-between">
          <div className="h-4 w-1"></div>
          {/* <div className="h-4 bg-white w-1"></div> */}
          <div className="h-4 bg-white w-1"></div>
          <div className="h-4 bg-white w-1"></div>
          <div className="h-4 bg-white w-1"></div>
          <div className="h-4 bg-white w-1"></div>
          <div className="h-4 w-1"></div>
        </div>
      </div>
      <Outlet
        context={{
          setProgress,
        }}
      />
    </div>
  );
}
